import Loglevel from 'loglevel';
export const environment = {
    production: true,
    mode:"#env_mode#",
    endpointBackend: "",
    homePagePath: "/profile",
    appCode: 124,
    siteKey: "#site_key#",
    images_url:"#base_url#/images/",
    sub_state: '#sub_state#',
    my_host:"#base_url#",
    merchant_id:"#merchant_id#",
    insure_merchant_id:"#insure_merchant_id#",
    endpoint_payment:"#client_endpoint_payment#",
    endpoint_payment_common_charge : "#client_endpoint_payment#/common_charge",
    logger: {
      serverLoggingUrl: "/api/log_process",
      level: Loglevel.levels["#log_level#".toUpperCase()],
      serverLogLevel: Loglevel.levels["#log_level#".toUpperCase()],
      disableConsoleLogging: JSON.parse("#disableConsoleLogging#".toLowerCase())
    },
    x_code:"5aea730b-7f6d-4d6b-833b-0e74ffd488aa",
    cookie: "#cookie#",
    liff_id: "#liff_id#",
    user_id_mock: '#user_id_mock#',
    insure_electronic_channel: '#insure_electronic_channel#',
    mazda_electronic_channel: '#mazda_electronic_channel#',
    ford_electronic_channel: '#ford_electronic_channel#',
    mitsu_electronic_channel: '#mitsu_electronic_channel#',
    nissan_electronic_channel: '#nissan_electronic_channel#',
    log_level: '#log_level#',
    google_tage_analytic_config: "#google_tage_analytic_config#",
    termsUrlRedirectmazda: "#termsUrlRedirectmazda#",
    termsUrlRedirectford: "#termsUrlRedirectford#",
    liffMotorshowford: "#liffMotorshowford#",
    liffMotorshowmazda: "#liffMotorshowmazda#",
    motorshowLine: "#motorshowLine#",
    termsUrlRedirectmitsubishi: "#termsUrlRedirectmitsubishi#",
    liffMotorshowmitsubishi: "#liffMotorshowmitsubishi#",
    termsUrlRedirectNissan: "#termsUrlRedirectNissan#",
    buyInsureOnlineClsBtwDate: "#buyInsureOnlineClsBtwDate#",
    tag_version:"d.7.255",
    dazRedirectUrl:"#dazRedirectUrl#",
    digital_rm_url:"#digital_rm_url#",
    sourceOfData:{
      'insure': 15,
      'mazda': 16,
      'ford': 17,
      'nissan': 27,
      'mitsu': 11,
      'prim': 18,
      'lpp': 20,
      'gwm': 40
    },
    tss_url:"#tss_url#",
    user_management_url:"#user_management_url#",
    docsign_url:"#docsign_url#",
    docsign_data_key:"#docsign_data_key#",
    docsign_certification_name:"#docsign_certification_name#",
    google_api_key: "#google_api_key#",
    facebook_pixel_config: "#facebook_pixel_config#",
    gtag_tag_id: "#gtag_tag_id#",
    gtm_tag_id_1 : "#gtm_tag_id_1#",
    gtm_tag_id_2 : "#gtm_tag_id_2#",
    redirect_link_tiscoinsure: "#redirect_link_tiscoinsure#",
    digitalrm_frontend_url: "#digitalrm_frontend_url#",
    digitalrm_frontend_app_id: "#digitalrm_frontend_app_id#"
  };
